module.exports = __webpack_public_path__ + "img/luckyDraw_footer.fc104ee4.png";